

















import {Component, Vue, Inject} from 'vue-property-decorator';
import {SET_TRANSPOSE} from '@/store/modules/flexGridModule/flexGrid-mutation-types';

/**
 * Flex grid footer
 */
@Component
export default class FlexGridFooter extends Vue {
    @Inject() moduleName!: string;
    @Inject() commit!: Function;

    get transpose(): boolean {
        return this.$store.state[this.moduleName].transpose;
    }

    get transposeLoading(): boolean {
        return this.$store.state[this.moduleName].transposeLoading;
    }

    onTransposeSuccess() {
        this.$root.$emit(`flex-grid${this.moduleName}:transpose-save`);
    }

    onTransposeCancel() {
        this.commit(SET_TRANSPOSE, false);
    }
}
